import { Controller } from "@hotwired/stimulus";
import { inverseSuggestionsFor } from "../lib/relationship_inverses";

// Loose relationship label editing: preset chips fill the label input, the
// inverse label gets suggestions from the inverse map, and a mirror preview
// shows how each profile reads the pair.
export default class extends Controller {
  static targets = [
    "input",
    "inverseInput",
    "inverseSuggestWrap",
    "inverseSuggestList",
    "mirrorPreview",
    "mirrorMineTag",
    "mirrorTheirsTag",
  ];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly inverseInputTarget: HTMLInputElement;
  declare readonly inverseSuggestWrapTarget: HTMLElement;
  declare readonly inverseSuggestListTarget: HTMLElement;
  declare readonly mirrorPreviewTarget: HTMLElement;
  declare readonly mirrorMineTagTarget: HTMLElement;
  declare readonly mirrorTheirsTagTarget: HTMLElement;

  connect() {
    this.renderInverseUi();
  }

  pick(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    this.inputTarget.value = button.dataset.tag ?? button.innerText.trim();
    this.prefillInverse();
    this.renderInverseUi();
  }

  onLabelInput() {
    this.prefillInverse();
    this.renderInverseUi();
  }

  syncMirror() {
    const mine = this.inputTarget.value.trim();
    const theirs = this.inverseInputTarget.value.trim();
    this.mirrorPreviewTarget.classList.toggle("hidden", !(mine && theirs));
    this.mirrorMineTagTarget.textContent = mine;
    this.mirrorTheirsTagTarget.textContent = theirs;
  }

  private prefillInverse() {
    const suggestion = inverseSuggestionsFor(this.inputTarget.value)[0];
    if (suggestion) this.inverseInputTarget.value = suggestion;
  }

  private renderInverseUi() {
    const suggestions = inverseSuggestionsFor(this.inputTarget.value);
    this.inverseSuggestWrapTarget.classList.toggle("hidden", suggestions.length === 0);
    this.inverseSuggestListTarget.replaceChildren(
      ...suggestions.map((label) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "btn btn-outline btn-xs rounded-full font-normal";
        button.textContent = label;
        button.addEventListener("click", () => {
          this.inverseInputTarget.value = label;
          this.syncMirror();
        });
        return button;
      }),
    );
    this.syncMirror();
  }
}
